import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useMainContainerMinMargins } from '@v4/components/common/SectionItem'
import { useMemo } from 'react'
import useStyles from './Banner9_10.styled'

// eslint-disable-next-line camelcase
export const useBanner9_10 = props => {
	const { metaData } = props

	const minMargins = useMainContainerMinMargins()

	const isBackground = metaData.mobileImagePosition?.isBackgroundImage
	const isImageExist = !!metaData.mobileImage?.image || !!metaData.backgroundImage?.image
	const withMobileBgImage = isImageExist && !!isBackground

	const mobileDirection = metaData.mobileImagePosition?.contentReverseDirection()

	const { classes, cx } = useStyles({ ...props, minMargins, mobileDirection })

	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleAdditionalTextClick } = useFieldFocus({ metaData: metaData.additionalText })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.backgroundImage })
	const { handleFocus: handleMobileImageClick } = useFieldFocus({ metaData: metaData.mobileImage })
	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: additionalTextEditable, handleChange: handleAdditionalTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'additionalText',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const sxWhite = useMemo(
		() => ({
			white: {
				md: withMobileBgImage,
			},
		}),
		[withMobileBgImage],
	)

	const sx = useMemo(
		() => ({
			white: {
				md: withMobileBgImage,
			},
			shadow: {
				md: withMobileBgImage,
			},
		}),
		[withMobileBgImage],
	)

	return [
		{
			mobileImage: metaData.mobileImage?.image ? metaData.mobileImage : metaData.backgroundImage,
			desktopBgImage: metaData.backgroundImage,
			classes,
			cx,
			withMobileBgImage: isImageExist && !!isBackground,
			withDesktopBgImage: !!metaData.backgroundImage?.image,
			withMobileImage: isImageExist && !isBackground,
			contentWidth: metaData.contentWidth?.metaValue,
			textShadow: metaData.textShadow?.toNumber(),

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,
			sxWhite,
			sx,

			additionalText: metaData.additionalText?.metaValue,
			additionalTextKey: metaData.additionalText?.tierKey,
			additionalTextConfig: metaData.additionalText?.config,
			additionalTextEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextConfig: metaData.buttonText?.config,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonTextEditable,
		},
		{
			handleMobileImageClick: metaData.mobileImage?.image ? handleMobileImageClick : handleImageClick,
			handleDesktopImageClick: handleImageClick,

			handleTextClick,
			handleTextChange,

			handleButtonClick,
			handleButtonTextChange,

			handleAdditionalTextClick,
			handleAdditionalTextChange,
		},
	]
}
